import { useState } from 'react';

export const useHeroState = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(false);

  const getCurrentIndex = (value: number) => {
    setCurrentIndex(value);
  };

  const getCurrentActiveState = (value: boolean) => {
    setIsAutoPlay(value);
  };

  return {
    currentIndex,
    isAutoPlay,
    getCurrentIndex,
    getCurrentActiveState,
  };
};
